<!-- eslint-disable vue/multi-word-component-names -->
<!-- eslint-disable no-undef -->
<script setup>
import { reactive, ref } from "@vue/reactivity";
import axios from "axios";
import { useStore } from "vuex";
import { onBeforeMount } from "@vue/runtime-core";
import { useRoute, useRouter } from "vue-router";
import Placeholder from "@/components/Placeholder.vue";
import NavbarSecondDark from '@/components/NavbarSecondDark.vue';

import {
  alertError,
  alertSuccess,
  clearBase64,
  clearBase64App,
  formatDate,
} from "@/assets/js/utils";
import { VueSignaturePad } from "vue-signature-pad";
import Select2 from "vue3-select2-component";
import Spinner from "@/components/Spinner.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

let signaturePad = ref(null);
let store = useStore();
let route = useRoute();
let router = useRouter();
let form = reactive({
  event_id: route.params.id,
  registration_form_id: route.params.registrationFormId,
  questions: [],
  auto_approve: false,
  name: "",
  description: "",
  loading: false,
  loading_submit: false,
  itis: [],
});

function formatDatepicker(date) {
  return formatDate(date, "DD MMMM YYYY");
}

function getRegistrationForm() {
  form.loading = true;
  axios
    .get(
      `${store.state.urlNewEventFront}event/${route.params.id}/registration-form/${route.params.registrationFormId}`
    )
    .then((res) => {
      if (res.data.status != 200) throw new Error(res.data.message);
      form.questions = res.data.data.questions;
      form.auto_approve = res.data.data.auto_approve;
      form.name = res.data.data.name;
      form.description = res.data.data.description;
      form.event_id = res.data.data.event_id;
      document.title = res.data.data.name;
      form.loading = false;
      phoneInputs();
    })
    .catch((error) => {
      alertError(error.message);
      form.loading = false;
    });
}

onBeforeMount(() => {
  document.title = "Form Pendaftaran Event | MICE";

  getRegistrationForm();
});

function phoneInputs() {
  setTimeout(() => {
    let phoneInputFields = document.querySelectorAll(".phone-question");
    phoneInputFields.forEach((phoneInputField) => {
      form.itis.push(
        window.intlTelInput(phoneInputField, {
          utilsScript:
            "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
          preferredCountries: ["id", "us"],
          autoHideDialCode: false,
          separateDialCode: true,
          nationalMode: true,
        })
      );
    });
  }, 500);
}

function inputPhone(i) {
  let now = document.querySelector(`#phone-question-${i}`);
  let els = document.querySelectorAll(`.phone-question`);

  els.forEach((el, index) => {
    if (now.id == el.id) {
      let iti = form.itis[index].getSelectedCountryData();
      form.questions[i].iso = iti.iso2;
      form.questions[i].dc = iti.dialCode;
    }
  });
}

function submit() {
  form.loading_submit = true;
  axios
    .post(`${store.state.urlNewEventFront}event-user`, form, {
      headers: {
        Authorization: `${store.state.token}`,
      },
    })
    .then((res) => {
      if (res.data.status != 200) throw new Error(res.data.message);
      alertSuccess(res.data.message);
      let r = router.resolve({
        name: "EventDetailMice",
        params: { id: route.params.id },
      });
      window.location.href = r.href;
    })
    .catch((err) => {
      form.loading_submit = false;
      alertError(err.response.data.message);
    });
}

function save(i) {
  const { empty, data } = signaturePad.value[0].saveSignature();

  if (empty) {
    alertError("Signature can't be empty");
    return;
  }

  form.questions[i].answer = clearBase64(data);
  alertSuccess("Signature saved");
}

function clear(i) {
  signaturePad.value[0].clearSignature();
  form.questions[i].answer = "";
  alertSuccess("Signature cleared");
}

function changeFile(i) {
  const file = document.querySelector(`#file-${i}`).files[0];
  let ext = file.name.split(".").pop().toLowerCase();

  if (!["pdf", "jpg", "png", "jpeg", "webp"].includes(ext)) {
    alertError("File harus berupa pdf, jpg, png, jpeg, atau webp");
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    form.questions[i].ext = ext;
    if (["jpg", "png", "jpeg", "webp"].includes(ext)) {
      form.questions[i].answer = clearBase64(e.target.result);
    } else {
      form.questions[i].answer = clearBase64App(e.target.result);
    }
  };
}

function changeFileSub(idq, idopt, idqsub) {
  const file = document.querySelector(`#file-${idq}-${idopt}-${idqsub}`)
    .files[0];
  let ext = file.name.split(".").pop().toLowerCase();

  if (!["pdf", "jpg", "png", "jpeg", "webp"].includes(ext)) {
    alertError("File harus berupa pdf, jpg, png, jpeg, atau webp");
    return;
  }

  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = (e) => {
    form.questions[idq].options[idopt].questions[idqsub].ext = ext;
    if (["jpg", "png", "jpeg", "webp"].includes(ext)) {
      form.questions[idq].options[idopt].questions[idqsub].answer = clearBase64(
        e.target.result
      );
    } else {
      form.questions[idq].options[idopt].questions[idqsub].answer =
        clearBase64App(e.target.result);
    }
  };
}

function saveSub(idq, idopt, idqsub) {
  const { empty, data } = signaturePad.value[0].saveSignature();

  if (empty) {
    alertError("Signature can't be empty");
    return;
  }

  form.questions[idq].options[idopt].questions[idqsub].answer =
    clearBase64(data);
  alertSuccess("Signature saved");
}

function clearSub(idq, idopt, idqsub) {
  signaturePad.value[0].clearSignature();
  form.questions[idq].options[idopt].questions[idqsub].answer = "";
  alertSuccess("Signature cleared");
}

function styleSelectSearch() {
  let els = document.querySelectorAll(".select2");

  els.forEach((el) => {
    el.style.width = "100%";
  });
}

function submitPreview() {
  let submitModal = new bootstrap.Modal("#submitModal");
  submitModal.show();
}

function validateEmail(email, additional_form_id, elId) {
  if (email) {
    if (
      String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) == null
    ) {
      alertError("Please input valid email");
      document.querySelector(`#${elId}`).focus();
      return;
    }
    axios
      .post(
        `${store.state.urlNewEventFront}event-user/validate-email`,
        {
          email,
          additional_form_id,
        },
        {
          headers: {
            Authorization: `${store.state.token}`,
          },
        }
      )
      .then((res) => {
        if (res.data.status != 200) throw new Error(res.data.message);
      })
      .catch((err) => {
        form.loading_submit = false;
        alertError(err.response.data.message);
        document.querySelector(`#${elId}`).focus();
      });
  }
}
</script>

<template>
  <div class="">
    <NavbarSecondDark />
    <section class="container-xl my-5 px-lg-5">&nbsp;</section>

    <section>
      <div class="row justify-content-center px-5" v-if="form.loading">
        <div class="col-lg-7 px-lg-5">
          <Placeholder />
        </div>
        <div class="col-lg-7 px-lg-5">
          <Placeholder />
        </div>
        <div class="col-lg-7 px-lg-5">
          <Placeholder />
        </div>
        <div class="col-lg-7 px-lg-5">
          <Placeholder />
        </div>
      </div>

      <form @submit.prevent="submitPreview" v-if="!form.loading">
        <div class="row justify-content-center px-lg-5 px-3 text-primary-mice">
          <div class="col-lg-7 px-lg-5 mb-3">
            <div class="h3 fw-bold">{{ form.name }}</div>
          </div>
          <div class="col-lg-7 px-lg-5 mb-3 ql-editor" v-html="form.description"></div>
        </div>
        <div class="row justify-content-center px-lg-5 px-3">
          <div :class="`col-lg-7 px-lg-5 mb-3`" v-for="(q, idq) in form.questions" :key="idq">
            <label class="form-label fw-bold text-primary-mice" style="opacity: 1;" v-if="q.type != 'SUB'">{{ q.question
              }}
              <span v-if="q.mandatory == 1" class="text-danger small">*</span></label>
            <br />
            <input :placeholder="q.description" type="text" class="form-control" v-if="['EMAIL'].includes(q.type)"
              :required="q.mandatory == 1" v-model="q.answer" @blur="validateEmail(q.answer, q.uuid, `email-${q.uuid}`)"
              :id="`email-${q.uuid}`" />
            <input :placeholder="q.description" type="text" class="form-control" v-if="['TEXT'].includes(q.type)"
              :required="q.mandatory == 1" v-model="q.answer" />
            <Datepicker :placeholder="q.description" v-if="['DATE'].includes(q.type)" :required="q.mandatory == 1"
              v-model="q.answer" :format="formatDatepicker"></Datepicker>
            <!-- <input
              type="date"
              class="form-control"
              v-if="['DATE'].includes(q.type)"
              :required="q.mandatory == 1"
              v-model="q.answer"
            /> -->
            <input type="time" class="form-control" v-if="['TIME'].includes(q.type)" :required="q.mandatory == 1"
              v-model="q.answer" />
            <input type="number" class="form-control phone-question" placeholder="81233453678"
              :id="`phone-question-${idq}`" v-if="'PHONE' == q.type" @keyup="inputPhone(idq)" v-model="q.answer" />
            <textarea class="form-control" rows="3" v-if="'LONGTEXT' == q.type" :required="q.mandatory == 1"
              v-model="q.answer"></textarea>
            <input type="file" class="form-control" v-if="'FILE' == q.type" :id="`file-${idq}`"
              :required="q.mandatory == 1" @change="changeFile(idq)" />

            <div v-if="'SELECT' == q.type">
              <Select2 v-model="q.answer" :options="q.options" placeholder="Select choice" @select="styleSelectSearch"
                :required="q.mandatory == 1" />
              <!-- <select
                class="form-select"
                aria-label="Default select example"
                :required="q.mandatory == 1"
                v-model="q.answer"
              >
                <option value="" selected>Select choice</option>
                <option
                  :value="opt.uuid"
                  v-for="(opt, idopt) in q.options"
                  :key="idopt"
                >
                  {{ opt.value }}
                </option>
              </select> -->
              <div :class="`card card-body border-0 mt-3 ${q.answer == opt.uuid && opt.questions.length > 0
                ? ''
                : 'd-none'
                }`" :id="`csubq-${idq}-${idopt}`" v-for="(opt, idopt) in q.options" :key="idopt">
                <div class="row">
                  <div class="col-lg-12 mb-3" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                    <label class="form-label fw-bold">{{ qsub.question }}
                      <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                    <br />
                    <label class="form-label small fw-light" v-if="qsub.question != ''"
                      v-html="qsub.description"></label>
                    <input type="text" class="form-control" v-if="['EMAIl', 'TEXT'].includes(qsub.type)"
                      v-model="qsub.answer" />
                    <input type="date" class="form-control" v-if="['DATE'].includes(qsub.type)" v-model="qsub.answer" />
                    <input type="time" class="form-control" v-if="['TIME'].includes(qsub.type)" v-model="qsub.answer" />
                    <input type="number" class="form-control phone-question" placeholder="81233453678"
                      :id="`phone-question-${idq}-${idopt}-${idqsub}`" v-if="'PHONE' == qsub.type"
                      @keyup="inputPhone(idqsub)" v-model="qsub.answer" />
                    <textarea class="form-control" rows="3" v-if="'LONGTEXT' == qsub.type"
                      v-model="qsub.answer"></textarea>
                    <input type="file" class="form-control" v-if="'FILE' == qsub.type"
                      :id="`file-${idq}-${idopt}-${idqsub}`" @change="changeFileSub(idq, idopt, idqsub)" />
                    <div v-if="'SELECT' == qsub.type">
                      <Select2 v-model="qsub.answer" :options="qsub.options" placeholder="Select choic"
                        style="width: 100%" />
                    </div>
                    <!-- <select
                      class="form-select"
                      aria-label="Default select example"
                      v-model="qsub.answer"
                      v-if="'SELECT' == qsub.type"
                    >
                      <option value="" selected>Select choice</option>
                      <option
                        :value="optsub.uuid"
                        v-for="(optsub, idoptsub) in qsub.options"
                        :key="idoptsub"
                      >
                        {{ optsub.value }}
                      </option>
                    </select> -->
                    <div v-if="'CHECKBOX' == qsub.type">
                      <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                        <input class="form-check-input" type="checkbox" :id="`checkopt-${idq}-${idoptsub}-${idqsub}`"
                          v-model="qsub.answer" :value="optsub.uuid" />
                        <label class="form-check-label" :for="`checkopt-${idq}-${idoptsub}-${idqsub}`">
                          {{ optsub.value }}
                        </label>
                      </div>
                    </div>
                    <div v-if="'RADIO' == qsub.type">
                      <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                        <input class="form-check-input" type="radio" :name="`namerad-${idq}-${idqsub}`"
                          :value="optsub.uuid" :for="`rad-${idq}-${idoptsub}-${idqsub}`" v-model="qsub.answer" />
                        <label class="form-check-label" :for="`rad-${idq}-${idoptsub}-${idqsub}`">
                          {{ optsub.value }}
                        </label>
                      </div>
                    </div>
                    <div class="row" v-if="'SIGNATURE' == qsub.type">
                      <div class="col-lg-10 mb-3">
                        <div class="border rounded-custom">
                          <VueSignaturePad ref="signaturePad" />
                        </div>
                      </div>
                      <div class="col-lg-2">
                        <button class="btn btn-sm rounded-custom bg-secondary-mice me-2" type="button"
                          @click.prevent="saveSub(idq, idopt, idqsub)">
                          <i class="fas fa-check text-white"></i>
                        </button>
                        <button class="btn btn-sm rounded-custom bg-warning-mice" type="button"
                          @click.prevent="clearSub(idq, idopt, idqsub)">
                          <i class="fas fa-times text-white"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="'CHECKBOX' == q.type">
              <div class="form-check" v-for="(opt, idopt) in q.options" :key="idopt">
                <input class="form-check-input" type="checkbox" :id="`checkopt-${idq}-${idopt}`" v-model="q.answer"
                  :value="opt.uuid" @click="() => {
                    q.answer.includes(opt.uuid)
                      ? q.answer.splice(q.answer.indexOf(opt.uuid), 1)
                      : q.answer.push(opt.uuid);
                    opt.open = !opt.open;
                  }
                    " />
                <label class="form-check-label" :for="`checkopt-${idq}-${idopt}`">{{ opt.value }}
                </label>
                <div :class="`card card-body border-0 ${opt.open ? '' : 'd-none'}`" :id="`csubq-${idq}-${idopt}`"
                  v-if="opt.questions.length > 0">
                  <div class="row">
                    <div class="col-lg-12 mb-3" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                      <label class="form-label fw-bold">{{ qsub.question }}
                        <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                      <br />
                      <label class="form-label small fw-light" v-if="qsub.question != ''"
                        v-html="qsub.description"></label>
                      <input type="text" class="form-control" v-if="['EMAIL', 'TEXT'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="date" class="form-control" v-if="['DATE'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="time" class="form-control" v-if="['TIME'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="number" class="form-control phone-question" placeholder="81233453678"
                        :id="`phone-question-${idq}-${idopt}-${idqsub}`" v-if="'PHONE' == qsub.type"
                        @keyup="inputPhone(idqsub)" v-model="qsub.answer" />
                      <textarea class="form-control" rows="3" v-if="'LONGTEXT' == qsub.type"
                        v-model="qsub.answer"></textarea>
                      <input type="file" class="form-control" v-if="'FILE' == qsub.type"
                        :id="`file-${idq}-${idopt}-${idqsub}`" @change="changeFileSub(idq, idopt, idqsub)" />
                      <Select2 v-model="qsub.answer" :options="qsub.options" placeholder="Select choice"
                        v-if="'SELECT' == qsub.type" />
                      <!-- <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="qsub.answer"
                        v-if="'SELECT' == qsub.type"
                      >
                        <option value="" selected>Select choice</option>
                        <option
                          :value="optsub.uuid"
                          v-for="(optsub, idoptsub) in qsub.options"
                          :key="idoptsub"
                        >
                          {{ optsub.value }}
                        </option>
                      </select> -->
                      <div v-if="'CHECKBOX' == qsub.type">
                        <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                          <input class="form-check-input" type="checkbox" :id="`checkopt-${idq}-${idoptsub}-${idqsub}`"
                            v-model="qsub.answer" :value="optsub.uuid" />
                          <label class="form-check-label" :for="`checkopt-${idq}-${idoptsub}-${idqsub}`">
                            {{ optsub.value }}
                          </label>
                        </div>
                      </div>
                      <div v-if="'RADIO' == qsub.type">
                        <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                          <input class="form-check-input" type="radio" :name="`namerad-${idq}-${idqsub}`"
                            :value="optsub.uuid" :for="`rad-${idq}-${idoptsub}-${idqsub}`" v-model="qsub.answer" />
                          <label class="form-check-label" :for="`rad-${idq}-${idoptsub}-${idqsub}`">
                            {{ optsub.value }}
                          </label>
                        </div>
                      </div>
                      <div class="row" v-if="'SIGNATURE' == qsub.type">
                        <div class="col-lg-10 mb-3">
                          <div class="border rounded-custom">
                            <VueSignaturePad ref="signaturePad" />
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <button class="btn btn-sm rounded-custom bg-secondary-mice me-2" type="button"
                            @click.prevent="saveSub(idq, idopt, idqsub)">
                            <i class="fas fa-check text-white"></i>
                          </button>
                          <button class="btn btn-sm rounded-custom bg-warning-mice" type="button"
                            @click.prevent="clearSub(idq, idopt, idqsub)">
                            <i class="fas fa-times text-white"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="'RADIO' == q.type">
              <div class="form-check" v-for="(opt, idopt) in q.options" :key="idopt">
                <input class="form-check-input" type="radio" :name="`namerad-${idq}`" :value="opt.uuid"
                  :id="`checkrad-${idq}-${idopt}`" :required="q.mandatory == 1" v-model="q.answer" />
                <label class="form-check-label" :for="`checkrad-${idq}-${idopt}`">
                  {{ opt.value }}
                </label>
                <div :class="`card card-body border-0 ${q.answer == opt.uuid ? '' : 'd-none'
                  }`" :id="`csubq-${idq}-${idopt}`" v-if="opt.questions.length > 0">
                  <div class="row">
                    <div class="col-lg-12 mb-3" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                      <label class="form-label fw-bold">{{ qsub.question }}
                        <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                      <br />
                      <label class="form-label small fw-light" v-if="qsub.question != ''"
                        v-html="qsub.description"></label>
                      <input type="text" class="form-control" v-if="['EMAIL', 'TEXT'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="date" class="form-control" v-if="['DATE'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="time" class="form-control" v-if="['TIME'].includes(qsub.type)"
                        v-model="qsub.answer" />
                      <input type="number" class="form-control phone-question" placeholder="81233453678"
                        :id="`phone-question-${idq}-${idopt}-${idqsub}`" v-if="'PHONE' == qsub.type"
                        @keyup="inputPhone(idqsub)" v-model="qsub.answer" />
                      <textarea class="form-control" rows="3" v-if="'LONGTEXT' == qsub.type"
                        v-model="qsub.answer"></textarea>
                      <input type="file" class="form-control" v-if="'FILE' == qsub.type"
                        :id="`file-${idq}-${idopt}-${idqsub}`" @change="changeFileSub(idq, idopt, idqsub)" />
                      <Select2 v-model="qsub.answer" :options="qsub.options" placeholder="Select choice"
                        v-if="'SELECT' == qsub.type" />
                      <!-- <select
                        class="form-select"
                        aria-label="Default select example"
                        v-model="qsub.answer"
                        v-if="'SELECT' == qsub.type"
                      >
                        <option value="" selected>Select choice</option>
                        <option
                          :value="optsub.uuid"
                          v-for="(optsub, idoptsub) in qsub.options"
                          :key="idoptsub"
                        >
                          {{ optsub.value }}
                        </option>
                      </select> -->
                      <div v-if="'CHECKBOX' == qsub.type">
                        <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                          <input class="form-check-input" type="checkbox" :id="`checkopt-${idq}-${idoptsub}-${idqsub}`"
                            v-model="qsub.answer" :value="optsub.uuid" />
                          <label class="form-check-label" :for="`checkopt-${idq}-${idoptsub}-${idqsub}`">
                            {{ optsub.value }}
                          </label>
                        </div>
                      </div>
                      <div v-if="'RADIO' == qsub.type">
                        <div class="form-check" v-for="(optsub, idoptsub) in qsub.options" :key="idoptsub">
                          <input class="form-check-input" type="radio" :name="`namerad-${idq}-${idqsub}`"
                            :value="optsub.uuid" :for="`rad-${idq}-${idoptsub}-${idqsub}`" v-model="qsub.answer" />
                          <label class="form-check-label" :for="`rad-${idq}-${idoptsub}-${idqsub}`">
                            {{ optsub.value }}
                          </label>
                        </div>
                      </div>
                      <div class="row" v-if="'SIGNATURE' == qsub.type">
                        <div class="col-lg-10 mb-3">
                          <div class="border rounded-custom">
                            <VueSignaturePad ref="signaturePad" />
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <button class="btn btn-sm rounded-custom bg-secondary-mice me-2" type="button"
                            @click.prevent="saveSub(idq, idopt, idqsub)">
                            <i class="fas fa-check text-white"></i>
                          </button>
                          <button class="btn btn-sm rounded-custom bg-warning-mice" type="button"
                            @click.prevent="clearSub(idq, idopt, idqsub)">
                            <i class="fas fa-times text-white"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="'SIGNATURE' == q.type">
              <div class="col-lg-10 mb-3">
                <div class="border rounded-custom">
                  <VueSignaturePad ref="signaturePad" />
                </div>
              </div>
              <div class="col-lg-2">
                <button class="btn btn-sm rounded-custom bg-secondary-mice me-2" type="button"
                  @click.prevent="save(idq)">
                  <i class="fas fa-check text-white"></i>
                </button>
                <button class="btn btn-sm rounded-custom bg-warning-mice" type="button" @click.prevent="clear(idq)">
                  <i class="fas fa-times text-white"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center px-lg-5 px-3">
          <div class="col-lg-7 px-lg-5">
            <div class="row">
              <div class="col-lg-6 mb-3 p-0">
                <div class="d-grid">
                  <button class="btn btn-sm btn-warning-mice px-5 mx-2 rounded-custom border-0 py-2" type="submit">
                    <i class="fas fa-eye me-2"></i> Preview
                  </button>
                </div>
              </div>
              <div class="col-lg-6 mb-3 p-0">
                <div class="d-grid">
                  <button class="btn btn-sm btn-primary-mice mx-2 rounded-custom border-0 py-2" type="submit"
                    :disabled="form.loading_submit">
                    <Spinner class="me-2" v-if="form.loading_submit" />
                    <i class="fas fa-floppy-disk me-2"></i> Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="modal fade" id="submitModal" tabindex="-1" aria-labelledby="submitModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="submitModalLabel">
                Preview Form
              </h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submit" v-if="!form.loading">
                <div class="row justify-content-center">
                  <div class="col-lg-12 mb-3" v-for="(q, idq) in form.questions" :key="idq">
                    <label class="form-label fw-bold" v-if="q.type != 'SUB'">{{ q.question }}
                      <span v-if="q.mandatory == 1" class="text-danger small">*</span></label>
                    <br v-if="q.type != 'SUB'" />
                    <div v-if="q.type == 'SUB'" v-html="q.description"></div>
                    <div v-if="
                      ['EMAIL', 'TEXT', 'DATE', 'TIME', 'LONGTEXT'].includes(
                        q.type
                      )
                    ">
                      {{ q.answer }}
                    </div>
                    <div v-if="['PHONE'].includes(q.type)">
                      {{ q.dc }}{{ q.answer }}
                    </div>
                    <div v-if="['FILE', 'SIGNATURE'].includes(q.type)">
                      <a :href="q.answer" target="_blank" class="text-decoration-none">Preview</a>
                    </div>
                    <div v-if="'SELECT' == q.type">
                      <div :class="`card card-body border-0 ${q.answer == opt.uuid ? '' : 'd-none'
                        }`" :id="`csubq-${idq}-${idopt}`" v-for="(opt, idopt) in q.options" :key="idopt">
                        <span v-if="q.answer == opt.uuid">{{ opt.value }}</span>
                        <div class="row" v-if="opt.questions.length > 0">
                          <div class="col-lg-12 mb-3" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                            <label class="form-label fw-bold">{{ qsub.question }}
                              <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                            <br />
                            <div v-if="
                              [
                                'EMAIL',
                                'TEXT',
                                'DATE',
                                'TIME',
                                'LONGTEXT',
                              ].includes(qsub.type)
                            ">
                              {{ qsub.answer }}
                            </div>
                            <div v-if="['PHONE'].includes(qsub.type)">
                              {{ qsub.dc }}{{ qsub.answer }}
                            </div>
                            <div v-if="['FILE', 'SIGNATURE'].includes(qsub.type)">
                              <a :href="qsub.answer" target="_blank" class="text-decoration-none">Preview</a>
                            </div>
                            <div v-if="'SELECT' == qsub.type">
                              <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                {{ qoptsub.value }}
                              </div>
                            </div>
                            <div v-if="'CHECKBOX' == qsub.type">
                              <div :class="qsub.answer.includes(qoptsub.uuid)
                                ? ''
                                : 'd-none'
                                " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                - {{ qoptsub.value }}
                              </div>
                            </div>
                            <div v-if="'RADIO' == qsub.type">
                              <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                {{ qoptsub.value }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="'CHECKBOX' == q.type">
                      <div :class="`form-check ${q.answer.includes(opt.uuid) ? '' : 'd-none'
                        }`" v-for="(opt, idopt) in q.options" :key="idopt">
                        <div v-if="q.answer.includes(opt.uuid)">
                          <div>- {{ opt.value }}</div>
                          <div class="row" v-if="opt.questions.length > 0">
                            <div class="col-lg-12" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                              <label class="form-label fw-bold">{{ qsub.question }}
                                <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                              <br />
                              <div v-if="
                                [
                                  'EMAIL',
                                  'TEXT',
                                  'DATE',
                                  'TIME',
                                  'LONGTEXT',
                                ].includes(qsub.type)
                              ">
                                {{ qsub.answer }}
                              </div>
                              <div v-if="['PHONE'].includes(qsub.type)">
                                {{ qsub.dc }}{{ qsub.answer }}
                              </div>
                              <div v-if="['FILE', 'SIGNATURE'].includes(qsub.type)">
                                <a :href="qsub.answer" target="_blank" class="text-decoration-none">Preview</a>
                              </div>
                              <div v-if="'SELECT' == qsub.type">
                                <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  {{ qoptsub.value }}
                                </div>
                              </div>
                              <div v-if="'CHECKBOX' == qsub.type">
                                <div :class="qsub.answer.includes(qoptsub.uuid)
                                  ? ''
                                  : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  - {{ qoptsub.value }}
                                </div>
                              </div>
                              <div v-if="'RADIO' == qsub.type">
                                <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  {{ qoptsub.value }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="'RADIO' == q.type">
                      <div :class="`form-check ${q.answer.includes(opt.uuid) ? '' : 'd-none'
                        }`" v-for="(opt, idopt) in q.options" :key="idopt">
                        <div v-if="q.answer == opt.uuid">
                          <div>{{ opt.value }}</div>
                          <div class="row">
                            <div class="col-lg-12" v-for="(qsub, idqsub) in opt.questions" :key="idqsub">
                              <label class="form-label fw-bold">{{ qsub.question }}
                                <span v-if="qsub.mandatory == 1" class="text-danger small">*</span></label>
                              <br />
                              <div v-if="
                                [
                                  'EMAIL',
                                  'TEXT',
                                  'DATE',
                                  'TIME',
                                  'LONGTEXT',
                                ].includes(qsub.type)
                              ">
                                {{ qsub.answer }}
                              </div>
                              <div v-if="['PHONE'].includes(qsub.type)">
                                {{ qsub.dc }}{{ qsub.answer }}
                              </div>
                              <div v-if="['FILE', 'SIGNATURE'].includes(qsub.type)">
                                <a :href="qsub.answer" target="_blank" class="text-decoration-none">Preview</a>
                              </div>
                              <div v-if="'SELECT' == qsub.type">
                                <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  {{ qoptsub.value }}
                                </div>
                              </div>
                              <div v-if="'CHECKBOX' == qsub.type">
                                <div :class="qsub.answer.includes(qoptsub.uuid)
                                  ? ''
                                  : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  - {{ qoptsub.value }}
                                </div>
                              </div>
                              <div v-if="'RADIO' == qsub.type">
                                <div :class="qsub.answer == qoptsub.uuid ? '' : 'd-none'
                                  " v-for="(qoptsub, iqoptsub) in qsub.options" :key="iqoptsub">
                                  {{ qoptsub.value }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-5">
                    <div class="d-grid">
                      <button class="btn btn-sm btn-primary-mice mx-2 rounded-custom border-0 py-2" type="submit"
                        :disabled="form.loading_submit">
                        <Spinner class="me-2" v-if="form.loading_submit" />
                        <i class="fas fa-floppy-disk me-2"></i> Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="container-xl my-5 px-lg-5">&nbsp;</section>
  </div>
</template>
